/** Lazy-load Ant Design notification so services (e.g. clientAPI) never import antd at module init. */
export function notifySuccess(title: string, message: string): void {
    void import("../components/shared/notification/NotificationComponent").then(
        ({ SuccessNotification }) => {
            SuccessNotification(title, message);
        },
    );
}

export function notifyFailed(title: string, message: string): void {
    void import("../components/shared/notification/NotificationComponent").then(
        ({ FailedNotification }) => {
            FailedNotification(title, message);
        },
    );
}
